<div class="header-container">
  <div class="header-top">
    <div class="title-header">
      <h1 class="title font-600">{{ title }}</h1>
      <p class="sub-title font-400">{{ subTitle }}</p>
    </div>

    <div class="actions-header" *ngIf="isCadastrarProdutos">
      <div class="mode-switch">
        <span class="mode-title font-400">Modo de Visualização</span>
        <div class="mode-option">
          <button
            class="mode-option font-600"
            [class.active]="viewMode === 'grid'"
            (click)="setViewMode('grid')"
            type="button"
          >
            <mat-icon fontSet="material-icons-outlined">grid_view</mat-icon>
            Grid
          </button>
          <button
            class="mode-option font-600"
            [class.active]="viewMode === 'list'"
            (click)="setViewMode('list')"
            type="button"
          >
            <mat-icon>view_list</mat-icon>
            Lista
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isLoja && !isConfiguracoes && !isPlayer"
    class="content-header flex-between"
  >
    <div class="search-wrapper">
      <input
        class="search-bar"
        type="text"
        [placeholder]="textPlaceholder"
        [value]="searchValue"
        (input)="onSearchInput($event)"
      />
      <mat-icon class="search-icon">search</mat-icon>
      <button
        *ngIf="isPedidos && (!downloadDisabled || !hideDownloadWhenDisabled)"
        type="button"
        class="btn-download"
        [disabled]="downloadDisabled"
        matTooltip="Download"
        matTooltipPosition="right"
        (click)="onDownloadClick()">
        <mat-icon class="icon-download" fontSet="material-icons-outlined">cloud_download</mat-icon>
      </button>
    </div>

    <div
      *ngIf="!isLoja && !isConfiguracoes && !isPedidos && !isClientes"
      class="btns-header"
    >
      <span
        class="first-btn-wrapper"
        [matTooltip]="firstBtnDisabledReason"
        [matTooltipDisabled]="!firstBtnDisabled || !firstBtnDisabledReason"
        matTooltipPosition="below"
      >
        <button
          class="first-btn font-600"
          type="button"
          [disabled]="firstBtnDisabled"
          (click)="clickFirstButton()"
        >
          {{ firstBtnText }}
          <mat-icon fontSet="material-icons-outlined">{{ iconFirstBtn }}</mat-icon>
        </button>
      </span>

      <button *ngIf="!isCadastrarProdutos" class="second-btn font-600" (click)="clickSecondButton()">
        {{ secondBtnText }}
        <mat-icon fontSet="material-icons-outlined">{{ iconSecondBtn }}</mat-icon>
      </button>

      <div class="planilha-menu" *ngIf="isCadastrarProdutos; else defaultThirdButton">
        <button class="third-btn font-600" type="button" (click)="togglePlanilhaMenu()">
          {{ thirdBtnText }}
          <mat-icon fontSet="material-icons-outlined">{{ iconThirdBtn }}</mat-icon>
        </button>

        <div class="planilha-dropdown" *ngIf="isPlanilhaMenuOpen">
          <button type="button" (click)="selectPlanilhaAction('download-template')">
            Baixar modelo (exemplo para preencher)
          </button>
          <button type="button" (click)="selectPlanilhaAction('import')">
            Importar produto (adicionar produtos)
          </button>
          <button type="button" (click)="selectPlanilhaAction('export')">
            Exportar produtos (baixar lista atual)
          </button>
        </div>
      </div>

      <ng-template #defaultThirdButton>
        <button class="third-btn font-600" (click)="clickThirdButton()">
          {{ thirdBtnText }}
          <mat-icon fontSet="material-icons-outlined">{{ iconThirdBtn }}</mat-icon>
        </button>
      </ng-template>
    </div>
  </div>
</div>
